import React from 'react'
import decodeUrl from "../../../utility-tools/decodeUrl";
import { v4 as uuidv4 } from 'uuid';

import {
    Badge,
    Button,
    ButtonGroup,
    Collapse,
    List,
    ListItemButton,
    ListItemText,
    Menu,
    Typography,
  } from "@mui/material";
import { updateIndex, zoomToFeature } from "./FeatureWidgetVM";
import {AddGraphicsFromURL} from "../../custom/assessor-add-graphic-from-url/AddGraphicFromUrlVM";
import addSelectedFeatureToSelectionLayer from "../../../utility-tools/addSelectedFeatureToSelection";
import removeSelectedFeatureFromSelectionLayer from "../../../utility-tools/removeSelectedFeatureFromSelection";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import ListIcon from '@mui/icons-material/List';
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const FeatureToolbar = ({view,menuOptions,featuresArray,selectedFeatureIndex,selectedFeatureType, openLayerDict, setOpenLayerDict,featureCount}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

      //
  // const prevReload = () =>{
  //   const copyArray= prevFeaturesArray.map((feature)=>{
  //     return feature.clone()
  //   })
  //   view.popup.features=prevFeaturesArray;
  //   //AddGraphicsFromURL(view,parcels)
  // }

    const zoomToFeature = (view) => {
        if (view.popup.selectedFeature.layer.geometryType === 'multipoint'){
    
          const selectlayer = view.popup.selectedFeature.layer
          let queryselect = selectlayer.createQuery();
          queryselect.returnGeometry = true;
          queryselect.outFields = ["*"];
          queryselect.spatialRelationship = "intersects"; 
          queryselect.where = "OBJECTID =" + view.popup.selectedFeature.attributes.OBJECTID;
          selectlayer.queryFeatures(queryselect)
          .then(function(results){
              if (results.features[0].geometry['points'].length > 1){
                view.goTo(results.features[0].geometry)
              } else {
                view.goTo({
                  target: results.features[0].geometry,
                  zoom: 15
                });
                
              }
    
            })   
        }
         else if (view.popup.selectedFeature.layer.geometryType === 'point'){
          view.goTo({
            target: view.popup.selectedFeature,
            zoom: 15
          });
          
        } 
        else  {
          view.goTo(view.popup.selectedFeature)
        }
      };
      const menuItemArray = Object.keys(menuOptions).map(
        (menuOptionKeyName, menuOptionIndex) => {
          const menuItems = menuOptions[menuOptionKeyName].list.map(
            (menuOptionItem) => {
              const newStringArray = menuOptionItem.fieldList.map((fieldName) => {
                if (featuresArray[menuOptionItem.index]?.attributes[fieldName]) {
                  return `${
                    featuresArray[menuOptionItem.index].attributes[fieldName]
                  } `;
                } else {
                  return `record ${menuOptionItem.index + 1} `;
                }
              });
              return (
                <List key={`${newStringArray.join("")}-feature-list-${uuidv4()}`} component="div" disablePadding>
                  <ListItemButton
                    key={`${newStringArray.join("")}-${menuOptionItem.index}-${uuidv4()}`}
                    sx={{ pl: 4 }}
                    onClick={() => {
                      updateIndex(menuOptionItem.index, selectedFeatureIndex, view);
                      setOpenLayerDict((prevOpenLayerDict) => {
                        const updatedDict = { ...prevOpenLayerDict };
                      
                        // Set every key to false
                        for (const key in updatedDict) {
                          updatedDict[key] = false;
                        }
                      
                        return updatedDict;
                      });
                      handleClose();
                    }}
                  >
                    <ListItemText primary={`${newStringArray[0]}`}
                    secondary={newStringArray.length>1?newStringArray[1]:""} />
                  </ListItemButton>
                </List>
              );
            }
          );
          const subheaderContent = (
            <Badge
              sx={{ marginRight: "12px" }}
              color="secondary"
              badgeContent={<span style={{color:'white'}}>{menuItems.length} </span>}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            ></Badge>
          );
          return [
            <List>
              <ListItemButton
                onClick={() => {
                  setOpenLayerDict((prevOpenLayerDict) => ({
                    ...prevOpenLayerDict,
                    [menuOptions[menuOptionKeyName].layerName]:
                      !prevOpenLayerDict[menuOptions[menuOptionKeyName].layerName],
                  }));
                }}
              >
                {subheaderContent}
                <Typography variant='h6' color="primary">
                {menuOptions[menuOptionKeyName].layerName}
                </Typography>
              </ListItemButton>
              <Collapse
                in={openLayerDict[menuOptions[menuOptionKeyName].layerName]}
                timeout="auto"
                unmountOnExit
              >
                {menuItems}
              </Collapse>
            </List>,
          ];
        }
      );
      const handleClose = () => {
        setAnchorEl(null);
      };
  return (
    <>
    {featureCount ? (
        <nav>
          <ButtonGroup>
          {selectedFeatureType === "feature" ? (
            <Button
            size="small"
            variant="contained"
            color="secondary"
            title="add identified feature to selection"
              onClick={() => addSelectedFeatureToSelectionLayer(view)}
            >
              <div className="primary-color-hover" style={{display:"flex", flexDirection:"row",alignItems:"center"}}><AddCircleOutlineIcon fontSize="small"/>Selection</div>
              </Button>
          ) : (
            ""
          )}
          {selectedFeatureType === "graphics" ? (
            <Button
            // startIcon={}
            size="small"
            variant="contained"
            color="secondary"
            title="remove identified feature from selection"
              onClick={() => removeSelectedFeatureFromSelectionLayer(view)}
            >
             <div className="primary-color-hover" style={{display:"flex", flexDirection:"row",alignItems:"center"}}><DeleteIcon fontSize="small"/>Selection</div>
            </Button>
          ) : (
            ""
          )}
          
          <Button
            size="small"
            variant="contained"
            color="secondary"
            title="zoom to identified feature"
            onClick={() => zoomToFeature(view)}
          >
            <ZoomInIcon className="primary-color-hover"/>
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            title="previous identified feature"
            onClick={() => view.popup.previous()}
          >
            <FastRewindIcon className="primary-color-hover"/>
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            title="next identified feature"
            onClick={() => view.popup.next()}
          >
            <FastForwardIcon className="primary-color-hover"/>
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            id="identified-selection"
            title="list of identified features"
            aria-controls={Boolean(anchorEl) ? "positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={Boolean(anchorEl) ? "true" : undefined}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            <ListIcon className="primary-color-hover"/>
          </Button>
          </ButtonGroup>
          <Menu
            id="positioned-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {menuItemArray}
          </Menu>
          <Typography variant="h6">
            {selectedFeatureIndex} of {featureCount}
          </Typography>
        </nav>
      ) : (
        ""
      )}
      </>
  )
}

export default FeatureToolbar